var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"MEMBER.WALLET_PURCHASE_BANDS.HEADING\"></h4>\n<table class=\"table table-bordered\">\n<thead>\n</thead>\n<tbody>\n<tr ng-repeat=\"band in bands\">\n<td class=\"text-left\" translate=\"MEMBER.WALLET_PURCHASE_BANDS.$X_FOR_$Y\" translate-values=\"{X: band.wallet_amount, Y: band.actual_amount}\">\n</td>\n<td class=\"text-center\">\n<button type=\"button\" ng-click=\"purchaseBand(band)\" translate=\"MEMBER.WALLET_PURCHASE_BANDS.BUY_BTN\">\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n";
var id1="member/wallet-purchase-bands/wallet_purchase_bands.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/member/wallet-purchase-bands/wallet_purchase_bands.html
// module id = 1187
// module chunks = 0